(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9026],{

/***/ 76172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'KeyboardArrowLeft');
exports.Z = _default;

/***/ }),

/***/ 48317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
exports.Z = _default;

/***/ }),

/***/ 18137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authors/[id]",
      function () {
        return __webpack_require__(79617);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CustomRightArrow; },
/* harmony export */   "q": function() { return /* binding */ CustomLeftArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48317);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76172);






var buttonStyles = {
    zIndex: 2,
    buttonOffset: 15,
    borderRadius: "50%",
    textAlign: "center",
    border: "1.5px solid #D4A976",
    backgroundColor: "#202020",
    color: "#D4A976",
    top: "calc(50% - 25px)",
    width: "50px",
    height: "50px",
    lineHeight: "50px",
    cursor: "pointer"
};
var CustomLeftArrow = function(param) {
    var onClick = param.onClick, left = param.left, position = param.position;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buttonStyles), {
            left: left || 0,
            position: position || "absolute"
        }),
        onClick: function() {
            return onClick();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            fontSize: "large",
            style: {
                marginTop: "-0.25rem",
                marginRight: 2
            }
        })
    });
};
var CustomRightArrow = function(param) {
    var onClick = param.onClick, right = param.right, position = param.position;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buttonStyles), {
            right: right || 0,
            position: position || "absolute"
        }),
        onClick: function() {
            return onClick();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: "large",
            style: {
                marginTop: "-0.25rem",
                marginLeft: 2
            }
        })
    });
};


/***/ }),

/***/ 79617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Author/Author.module.scss
var Author_module = __webpack_require__(26852);
var Author_module_default = /*#__PURE__*/__webpack_require__.n(Author_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./components/News/News.module.scss
var News_module = __webpack_require__(26139);
var News_module_default = /*#__PURE__*/__webpack_require__.n(News_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(16494);
// EXTERNAL MODULE: ./components/Carousel/arrows/arrows.jsx
var arrows = __webpack_require__(9686);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 31 modules
var esm = __webpack_require__(28147);
;// CONCATENATED MODULE: ./components/News/News.jsx
















var responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: {
            max: 4000,
            min: 3000
        },
        items: 3,
        slidesToSlide: 3
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3,
        slidesToe: 3
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1,
        slideside: 1
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        sieTS: 1
    }
};
var ButtonGroup = function(param) {
    var next = param.next, previous = param.previous;
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "carousel-button-group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomLeftArrow */.q, {
                left: width < 1024 ? 0 : -40,
                position: "absolute",
                onClick: function() {
                    return previous();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrows/* CustomRightArrow */.i, {
                onClick: function() {
                    return next();
                },
                right: width < 1024 ? 0 : -40,
                position: "absolute"
            })
        ]
    });
};
var getNews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/article?&subtype=News&size=9")
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getNews() {
        return _ref.apply(this, arguments);
    };
}();
var News = function(param) {
    var news = param.news, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, _inverse = param.inverse, inverse = _inverse === void 0 ? false : _inverse;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)([]), articles = ref[0], setArticles = ref[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var ref1 = (0,react.useState)(0), carouselHeight = ref1[0], setCarouselHeight = ref1[1];
    var carousel = /*#__PURE__*/ (0,react.createRef)();
    (0,react.useEffect)(function() {
        var ref;
        setCarouselHeight(((ref = carousel.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) / 1.78);
    }, [
        carousel,
        width
    ]);
    (0,react.useEffect)(function() {
        if (!news) {
            getNews().then(function(res) {
                setArticles((0,_to_consumable_array/* default */.Z)(articles).concat((0,_to_consumable_array/* default */.Z)(res.content)));
            });
        } else {
            setArticles((0,_to_consumable_array/* default */.Z)(news));
        }
    }, [
        news
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((News_module_default()).newsContainer, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (News_module_default()).inverse, inverse), (0,_define_property/* default */.Z)(_obj, "bg-brown-background", !inverse), _obj)),
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((News_module_default()).heading, "font-fragment"),
                children: t("index.news")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                infinite: true,
                responsive: responsive,
                autoPlaySpeed: 5000,
                swipeable: true,
                draggable: false,
                arrows: false,
                renderButtonGroupOutside: true,
                slidesToSlide: width >= 1024 ? 3 : 1,
                containerClass: (News_module_default()).carouselContainer,
                customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                    width: width
                }),
                children: articles.map(function(item) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    if (((ref = item.image) === null || ref === void 0 ? void 0 : ref[0]) === "/") {
                        var ref6;
                        item.image = (ref6 = item.image) === null || ref6 === void 0 ? void 0 : ref6.replace("/", "");
                    }
                    if (((ref1 = item.topImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2[0]) === "/") {
                        var ref7;
                        item.topImage.image = (ref7 = item.topImage.image) === null || ref7 === void 0 ? void 0 : ref7.replace("/", "");
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/" + ((ref3 = item.type) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) + "/" + ((ref4 = item.subtype) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) + "/" + item.textId,
                        "aria-label": "Reas more",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cursor-pointer h-full",
                            style: {
                                marginRight: "1rem",
                                marginLeft: "1rem",
                                backgroundColor: inverse ? "white" : "transparent",
                                boxShadow: "0px 5px 5px 5px rgb(0 0 0 / 2%)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: carousel,
                                    style: {
                                        height: carouselHeight
                                    },
                                    className: classnames_default()((News_module_default()).carouselItem, "relative"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "https://media.first-class.com/" + (((ref5 = item.topImage) === null || ref5 === void 0 ? void 0 : ref5.image) || item.image),
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                }),
                                item.heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((News_module_default()).carouselItemOverline, "font-libre mt-2"),
                                    children: item.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((News_module_default()).carouselItemTitle, "font-fragment", {
                                        "mt-6": !item.heading
                                    }),
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()((News_module_default()).carouselItemContent, "font-libre"),
                                    dangerouslySetInnerHTML: {
                                        __html: item.content
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()((News_module_default()).readMore, "font-libre"),
                                    children: "Read more"
                                })
                            ]
                        })
                    }, item.textId);
                })
            })
        ]
    });
};
/* harmony default export */ var News_News = (News);

// EXTERNAL MODULE: ./public/LinkedIn.svg
var LinkedIn = __webpack_require__(1667);
// EXTERNAL MODULE: ./components/Breadcrumbs/Breadcrumbs.jsx
var Breadcrumbs = __webpack_require__(71186);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/Author/Author.jsx
















function AuthorProfile(param) {
    var author = param.author, articles = param.articles, airlineReviews = param.airlineReviews, hotelReviews = param.hotelReviews;
    var ref;
    var ref1 = (0,react.useState)(null), authorBio = ref1[0], setAuthorBio = ref1[1];
    var ref2 = (0,react.useState)([]), authorContent = ref2[0], setAuthorContent = ref2[1];
    (0,react.useEffect)(function() {
        if (author) {
            setAuthorBio((0,html_react_parser/* default */.ZP)(author.content));
            var incomingContent = (0,_to_consumable_array/* default */.Z)(articles.content.map(function(article) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
                    contentType: "article"
                });
            })).concat((0,_to_consumable_array/* default */.Z)(airlineReviews.content.map(function(airlineReview) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, airlineReview), {
                    contentType: "airlineReview"
                });
            })), (0,_to_consumable_array/* default */.Z)(hotelReviews.content.map(function(hotelReview) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotelReview), {
                    contentType: "hotelReview"
                });
            }))).sort(function(a, b) {
                return moment_default()(b.published, "YYYY-MM-DDTHH:mm").diff(moment_default()(a.published, "YYYY-MM-DDTHH:mm")) > 0 ? 1 : -1;
            });
            console.log(incomingContent.map(function(c) {
                return c.published + " " + c.title;
            }));
            setAuthorContent((0,_to_consumable_array/* default */.Z)(authorContent).concat((0,_to_consumable_array/* default */.Z)(incomingContent)));
        }
    }, [
        author
    ]);
    (0,react.useEffect)(function() {
        getAuthorContent();
    }, []);
    var mapAuthorContent = function(item) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            type: item.type ? item.type : item.contentType === "airlineReview" ? "airlines" : "hotel",
            title: item.contentType === "airlineReview" ? "".concat(item.title, " ").concat(item.cabinClass) : item.title,
            subtype: item.subtype ? item.subtype : item.contentType === "airlineReview" ? "reviews" : "review",
            heading: item.contentType === "airlineReview" ? "Airline Review" : item.contentType === "hotelReview" ? "Hotel Review" : null
        });
    };
    var getAuthorContent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, requestQueue, _tmp, contents, incomingContent;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,httpClient/* httpGet */.kA)("/api/author/".concat(author.textId.toLowerCase(), "/articles?page=0&size=10")).then(function(r) {
                                return r.json();
                            })
                        ];
                    case 1:
                        _tmp = [
                            _state.sent()
                        ];
                        return [
                            4,
                            (0,httpClient/* httpGet */.kA)("/api/author/".concat(author.textId.toLowerCase(), "/airline?page=0&size=10")).then(function(r) {
                                return r.json();
                            })
                        ];
                    case 2:
                        _tmp = _tmp.concat(_state.sent());
                        return [
                            4,
                            (0,httpClient/* httpGet */.kA)("/api/author/".concat(author.textId.toLowerCase(), "/hotel?page=0&size=10")).then(function(r) {
                                return r.json();
                            })
                        ];
                    case 3:
                        requestQueue = _tmp.concat(_state.sent());
                        return [
                            4,
                            Promise.all(requestQueue)
                        ];
                    case 4:
                        contents = _state.sent();
                        incomingContent = [];
                        if ((ref = contents[0].content) === null || ref === void 0 ? void 0 : ref.length) {
                            incomingContent.push(contents[0].content.map(function(article) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
                                    contentType: "article"
                                });
                            }));
                        }
                        if ((ref1 = contents[1].content) === null || ref1 === void 0 ? void 0 : ref1.length) {
                            incomingContent.push(contents[1].content.map(function(article) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
                                    contentType: "airlineReview"
                                });
                            }));
                        }
                        if ((ref2 = contents[2].content) === null || ref2 === void 0 ? void 0 : ref2.length) {
                            incomingContent.push(contents[2].content.map(function(article) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
                                    contentType: "hotelReview"
                                });
                            }));
                        }
                        incomingContent = incomingContent.flat().map(mapAuthorContent).sort(function(a, b) {
                            return moment_default()(b.published, "YYYY-MM-DDTHH:mm").diff(moment_default()(a.published, "YYYY-MM-DDTHH:mm")) > 0 ? 1 : -1;
                        });
                        setAuthorContent((0,_to_consumable_array/* default */.Z)(authorContent).concat((0,_to_consumable_array/* default */.Z)(incomingContent)));
                        return [
                            2
                        ];
                }
            });
        });
        return function getAuthorContent() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Author_module_default()).profileBG
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Author_module_default()).profileInfo),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Author_module_default()).profileImageWrapper,
                            children: [
                                !author.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Author_module_default()).profileImagePlaceholder,
                                    children: [
                                        author.user.firstName[0],
                                        author.user.lastName[0]
                                    ]
                                }),
                                author.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Author_module_default()).profileImage,
                                    children: author.image.startsWith("http") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: author.image,
                                        alt: "avatar",
                                        className: "w-full object-cover"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: author.image.startsWith("/") ? "https://media.first-class.com/" + ((ref = author.image) === null || ref === void 0 ? void 0 : ref.replace("/", "")) : "https://media.first-class.com/" + author.image,
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Author_module_default()).profileInfoWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((Author_module_default()).profileInfoName, "font-fragment"),
                                        children: [
                                            author.user.firstName,
                                            " ",
                                            !!author.user.lastName && author.user.lastName,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: author.profile,
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                                    className: (Author_module_default()).linkedInLogo
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((Author_module_default()).profileInfoEmail, "mb-2 text-center"),
                                        children: author.jobTitle
                                    }),
                                    author.alumni && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Author_module_default()).profileInfoEmail,
                                        children: author.alumni
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* BCBreadcrumbs */.k, {
                                        headerText: "".concat(author.user.firstName) + " ".concat(author.user.lastName || "")
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Author_module_default()).profileContents, "container mb-20"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Author_module_default()).authorBioContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (Author_module_default()).sectionHeader,
                                children: "About Author"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Author_module_default()).bio,
                                children: authorBio
                            })
                        ]
                    }),
                    !!authorContent.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (Author_module_default()).sectionHeader,
                                children: "Most recent content"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(News_News, {
                                news: authorContent,
                                showTitle: false,
                                inverse: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/authors/[id].jsx





function AuthorPage(param) {
    var author = param.author, articles = param.articles, airlineReviews = param.airlineReviews, hotelReviews = param.hotelReviews;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Author ",
                        author.user.firstName,
                        " ",
                        author.user.lastName,
                        " page - First-Class.com"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorProfile, {
                author: author,
                articles: articles,
                airlineReviews: airlineReviews,
                hotelReviews: hotelReviews
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var _id_ = ((0,Layout/* withLayout */.X)(AuthorPage, true));


/***/ }),

/***/ 26852:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileInfo":"Author_profileInfo__Ny8qh","tabHeadingWrapper":"Author_tabHeadingWrapper__FvCYu","profileInfoWrapper":"Author_profileInfoWrapper__8l_WA","profileInfoName":"Author_profileInfoName__X8wHZ","linkedInLogo":"Author_linkedInLogo__vKV7q","profileInfoEmail":"Author_profileInfoEmail__4Wsoq","profileImageWrapper":"Author_profileImageWrapper__z_pHl","profileImagePlaceholder":"Author_profileImagePlaceholder__uNCLz","profileImage":"Author_profileImage__LxTZU","profileBG":"Author_profileBG___Ocv5","profileContents":"Author_profileContents__BzWul","list":"Author_list__4TlW8","listItem":"Author_listItem__2VI28","sectionHeader":"Author_sectionHeader__bhuN9","authorBioContainer":"Author_authorBioContainer___zkeN","bio":"Author_bio__go0F2"};

/***/ }),

/***/ 26139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsContainer":"News_newsContainer__O1iGt","inverse":"News_inverse__P4hOY","newsOverflow":"News_newsOverflow__P1cTG","carouselItem":"News_carouselItem__6zDjL","heading":"News_heading__FHD0K","carouselItemTitle":"News_carouselItemTitle__rY8Th","carouselItemContent":"News_carouselItemContent__S_DcA","carouselItemOverline":"News_carouselItemOverline__X61GM","readMore":"News_readMore__cjt5n"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,2769,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(18137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);